import {
	Button,
	HStack,
	Input,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { SUBSCRIPTIONS_API_ROUTE } from 'apiRoutes';
import axios from 'axios';
import { FunctionComponent, useState } from 'react';

const GetCachedPermissionsTool: FunctionComponent = () => {
	const [subscriberId, setSubscriberId] = useState<string>('');
	const [permissions, setPermissions] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);

	const getPermissions = async (subscriberId: string) => {
		setLoading(true);
		axios
			.get(
				`${SUBSCRIPTIONS_API_ROUTE}/GetCachedPermissions?SubscriberId=${subscriberId}`,
			)
			.then((result) => {
				if (result.status == 200) {
					setPermissions(result.data);
				}
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<VStack>
			<Text>Get users&apos; cached permissions</Text>
			<HStack wrap="nowrap">
				<Input
					label="Subscriber ID"
					type="text"
					autoComplete="off"
					name="subscriberId"
					value={subscriberId}
					required
					onChange={(event) => setSubscriberId(event.target.value)}
				/>
			</HStack>
			<Button
				onClick={() => getPermissions(subscriberId)}
				type="submit"
				text="Get Permissions"
				loadingText="Getting permissions ..."
				isLoading={loading}
				isDisabled={!subscriberId.trim().length}
			/>
			{permissions && (
				<Text as="pre">{JSON.stringify(permissions, null, 2)}</Text>
			)}
		</VStack>
	);
};

export default GetCachedPermissionsTool;
